import { useNavigate } from "react-router-dom";
import backarrow from "../../../../assets/images/back-arrow-left.svg";
import closeicon from "../../../../assets/images/close.svg";
import { useTranslation } from "react-i18next";
import useLanguageTranslate from "../../../../hooks/useLanguageTranslate";
import useMotorFlow from "../../../../hooks/useMotorFlow";

const NewMotorJourneyLayout = ({
  children,
  is_hide_back_btn,
  show_close_btn,
  onClose,
  customBackHandler,
  isFirstPage = false, // New prop to determine if it's the first page (show close) or not (show back)
}) => {
  const navigate = useNavigate();
  const { handlePrevSubstep } = useMotorFlow();
  const translate = useLanguageTranslate();
  const { i18n } = useTranslation();
  const isRTL = i18n.resolvedLanguage === "ar";

  const handleNavigationClick = () => {
    // Close pages close, every other page goes back. `onClose` used to be
    // checked before `isFirstPage`, which meant a step that passed one got a
    // back button that closed the whole flow instead of stepping back.
    if (customBackHandler) {
      customBackHandler();
    } else if (isFirstPage || show_close_btn) {
      if (onClose) {
        onClose();
      } else {
        navigate("/new-policy");
      }
    } else {
      handlePrevSubstep();
    }
  };

  return (
    <div className="">
      {/* Mobile Navigation (visible <=767px). The bar itself is only a 56px
          spacer now — `pointer-events-none` so it never swallows a tap.
          The button is `fixed`, matching every other journey layout: as an
          `absolute` child of this `sticky` bar it scrolled away with the page,
          which none of the other flows do. `z-[100]` clears the popup Header's
          `fixed z-20` nav, which is opaque white over these exact pixels and
          would otherwise paint the button out of sight. */}
      <div className="hidden max767:block sticky top-0 left-0 right-0 z-50 max767:z-30 bg-white max767:bg-transparent pointer-events-none">
        <div className="flex items-center justify-between rtl:max767:justify-start h-14 px-4">
          {(!is_hide_back_btn || isFirstPage || show_close_btn) && (
            <button
              className={`pointer-events-auto flex items-center justify-center w-10 h-10 rounded-full bg-gray-100 hover:bg-gray-200 shadow-sm transition-colors fixed top-3 z-[100] ${isRTL ? 'right-4' : 'left-4'}`}
              onClick={handleNavigationClick}
            >
              {isFirstPage || show_close_btn ? (
                <img src={closeicon} alt="Close" className="w-5 h-5" />
              ) : (
                <img
                  src={backarrow}
                  alt="Back"
                  className={`w-5 h-5 ${isRTL ? "rotate-180" : ""}`}
                />
              )}
            </button>
          )}
          {/* Center space for potential title */}
          <div className="flex-1"></div>
          {/* Right space for potential actions */}
          <div className="w-10"></div>
        </div>
      </div>

      {/* Desktop Navigation (visible >767px) */}
      <div className="block max767:hidden">
        {!is_hide_back_btn && (
          <button
            className="backButton bg-navy-blue py-2 rounded mt-20 flex absolute left-[26px] rtl:right-[26px] top-0 text-black text-sm not-italic font-semibold leading-6 tracking-[-0.084px]"
            onClick={customBackHandler || handlePrevSubstep}
          >
            <img
              src={backarrow}
              alt="Back arrow"
              className="rtl:ml-[5px] rtl:rotate-[181deg]"
            />
            <span className="back-text inline">
              {translate("Back", "رجوع")}
            </span>
          </button>
        )}
        {show_close_btn && (
          <button
            className="py-2 hidden rounded mt-4 flex absolute top-0 text-black text-sm not-italic font-semibold leading-6 tracking-[-0.084px]"
            onClick={() => {
              if (onClose) {
                onClose();
              } else {
                navigate("/new-policy");
              }
            }}
          >
            <img src={closeicon} alt="Close Icon" />
          </button>
        )}
      </div>

      {/* Content with mobile padding */}
      <div className="max767:pt-8">
        {" "}
        {/* Increased padding to prevent overlap with fixed nav + stepper */}
        {children}
      </div>
    </div>
  );
};

export default NewMotorJourneyLayout;
